// extracted by mini-css-extract-plugin
export default {"icon":"PrivateSpaceIcon_icon__ckq+m"};